import { type Lang, COPY } from "../copy.js";

export function DetailsStrip({ lang }: { lang: Lang }) {
  const t = COPY[lang];
  return (
    <div className="wrap">
      <div className="strip">
        <div>
          <div className="t-label">{t.strip.date.label}</div>
          <div className="val">{t.strip.date.val}</div>
          <div className="sub">{t.strip.date.sub}</div>
        </div>
        <div>
          <div className="t-label">{t.strip.place.label}</div>
          <div className="val">{t.strip.place.val}</div>
          <div className="sub">{t.strip.place.sub}</div>
        </div>
      </div>
    </div>
  );
}
